export interface Insurer {
  name: string
  aliases: string[]
  type: "carrier" | "mga" | "program" | string
  parentGroup?: string | null
  claimsUrl: string | null
  phone: string | null
  phoneSourceUrl: string | null
  claimsEmail: string | null
  carrierInstructions: string | null
  panelVendorNote: string | null
  quoteUrl: string | null
  quoteNote: string | null
  verifiedOn: string
}

const norm = (s: string) =>
  s.toLowerCase().normalize("NFKD").replace(/&/g, " and ").replace(/[^a-z0-9]+/g, " ").replace(/\b(inc|llc|ltd|co|company|corp|corporation|group|insurance|the)\b/g, " ").replace(/\s+/g, " ").trim()

/** Score 0 = no match. Higher is better. Matches name, aliases, parent group; tolerant of punctuation and word order. */
export type Searchable = { name: string; aliases: string[]; parentGroup?: string | null }
export function scoreInsurer(i: Searchable, query: string): number {
  const q = norm(query)
  if (!q) return 0
  const fields = [i.name, ...i.aliases, i.parentGroup ?? ""].filter(Boolean).map(norm)
  const tokens = q.split(" ")
  let best = 0
  for (const f of fields) {
    if (!f) continue
    if (f === q) best = Math.max(best, 100)
    else if (f.startsWith(q)) best = Math.max(best, 80)
    else if (f.includes(q)) best = Math.max(best, 60)
    else if (tokens.every((t) => f.includes(t))) best = Math.max(best, 40)
  }
  return best
}

export function searchInsurers<T extends Searchable>(list: T[], query: string): T[] {
  const q = query.trim()
  if (!q) return [...list].sort((a, b) => a.name.localeCompare(b.name))
  return list
    .map((i) => ({ i, s: scoreInsurer(i, q) }))
    .filter((x) => x.s > 0)
    .sort((a, b) => b.s - a.s || a.i.name.localeCompare(b.i.name))
    .map((x) => x.i)
}
